(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const videos = new Set();
  const visible = new WeakMap();
  const allowAutoplay = () => !motion.matches && !navigator.connection?.saveData && !document.hidden;

  function update(video) {
    if (!visible.get(video) || !allowAutoplay()) {
      video.pause();
      return;
    }
    const promise = video.play();
    if (promise?.catch) promise.catch(() => {});
  }

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      visible.set(entry.target, entry.isIntersecting);
      update(entry.target);
    });
  }, { threshold: 0.05 }) : null;

  function init(root) {
    root.querySelectorAll('.cb-metal-silver-video').forEach(video => {
      if (video.dataset.cbMetalReady) return;
      video.dataset.cbMetalReady = 'true';
      videos.add(video);
      if (observer) observer.observe(video);
    });
  }

  function refresh() {
    videos.forEach(video => {
      if (!video.isConnected) {
        observer?.unobserve(video);
        videos.delete(video);
      } else update(video);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('visibilitychange', refresh);
  motion.addEventListener('change', refresh);
  navigator.connection?.addEventListener('change', refresh);
})();
